import { render, staticRenderFns } from "./TratamentoChecklist.vue?vue&type=template&id=781d80b2"
import script from "./TratamentoChecklist.vue?vue&type=script&lang=js"
export * from "./TratamentoChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports